(() => {
  const prefix = 'pb-identity:';
  const ttl = 15 * 60 * 1000;
  let inflight = null, lastRefresh = 0;
  function cacheKey(account) {
    const marker = document.cookie.split('; ').find(c => c.startsWith('pb-display-session='))?.split('=')[1];
    return marker ? prefix + 'app:' + marker : account.dataset.customerId ? prefix + 'shop:' + account.dataset.customerId : null;
  }
  function showAccount(signedIn) {
    document.querySelectorAll('[data-pb-account-menu]').forEach(el => {el.hidden = !signedIn;if(!signedIn)el.open=false;});
    document.querySelectorAll('[data-pb-account-login]').forEach(el => {el.hidden = signedIn;});
  }
  function apply(account, profile) {
    const label = account.querySelector('[data-pb-display-name]');
    const image = account.querySelector('[data-pb-profile-photo]');
    const icon = account.querySelector('svg');
    if (label) label.textContent = profile?.displayName || 'My Account';
    const photo = profile?.photo;
    const valid = typeof photo === 'string' && /^data:image\/(png|jpeg|webp);base64,/.test(photo);
    if (image) {
      if (valid) { if (image.getAttribute('src') !== photo) image.src = photo; }
      else image.removeAttribute('src');
      image.hidden = !valid;
    }
    if (icon) icon.style.display = valid ? 'none' : '';
    account.removeAttribute('data-identity-pending');
  }
  function restore(account) {
    if (account.dataset.identityRestored) return;
    account.dataset.identityRestored = 'true';
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey(account)) || 'null');
      if (cacheKey(account) && cached && Date.now() - cached.time < ttl) { apply(account, cached.profile); showAccount(true); }
    } catch { /* Storage may be disabled. */ }
  }
  async function refreshIdentity() {
    const accounts = [...document.querySelectorAll('[data-pb-identity][data-customer-id]')];
    if (!accounts.length) return;
    accounts.forEach(restore);
    if (inflight) return inflight;
    if (Date.now() - lastRefresh < 10000 && accounts.every(a => !a.hasAttribute('data-identity-pending'))) return;
    inflight = (async () => {
      try {
        let response = await fetch('https://account.playerboost.com/customer/identity', {credentials:'include',cache:'no-store'});
        if (!response.ok) return;
        let result = await response.json();
        // Preserve Shopify-native sign-in when there is no web-app session.
        if (!result.authenticated && accounts.some(a => a.dataset.customerId)) {
          response = await fetch('/apps/playerboost/profile', {credentials:'same-origin',cache:'no-store'});
          if (!response.ok) return;
          const fallback = await response.json();
          result = {authenticated:!!fallback.profile,profile:fallback.profile};
        }
        document.querySelectorAll('[data-pb-account-menu]').forEach(el => {el.hidden = !result.authenticated;if(el.hidden)el.open=false;});
        document.querySelectorAll('[data-pb-account-login]').forEach(el => {el.hidden = !!result.authenticated;});
        if (!response.ok) {
          if (response.status === 401 || response.status === 403) accounts.forEach(a => {
            try { sessionStorage.removeItem(cacheKey(a)); } catch {}
            apply(a, null);
          });
          return;
        }
        const {profile} = result;
        accounts.forEach(account => {
          apply(account, profile);
          try {
            if (profile && cacheKey(account)) sessionStorage.setItem(cacheKey(account), JSON.stringify({time:Date.now(),profile:{displayName:profile.displayName,photo:profile.photo}}));
            else sessionStorage.removeItem(cacheKey(account));
          } catch { /* Keep working when storage is full or unavailable. */ }
        });
        lastRefresh = Date.now();
      } catch { /* Keep the cached identity during transient errors. */ }
      finally { accounts.forEach(a => a.removeAttribute('data-identity-pending')); inflight = null; }
    })();
    return inflight;
  }
  document.addEventListener('submit', event => {
    if (!event.target.matches('.pb-account-menu form')) return;
    document.querySelectorAll('[data-pb-identity]').forEach(a => {try { sessionStorage.removeItem(cacheKey(a)); } catch {} apply(a,null);});
    showAccount(false);
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.pb-account-menu a[href*="logout"]')) return;
    document.querySelectorAll('[data-pb-identity]').forEach(a => {
      try { sessionStorage.removeItem(cacheKey(a)); } catch {}
    });
  });
  refreshIdentity();
  window.addEventListener('pageshow', refreshIdentity);
  window.addEventListener('focus', refreshIdentity);
  document.addEventListener('shopify:section:load', refreshIdentity);
})();
